import React, { Component } from "react";
import { handleKeyPress } from "../../../helpers/KeyPressHelper";

class InputTooltipIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolTipVisible: false
    };
  }

  render() {
    return (
      <React.Fragment>
        {this.props.tooltipContent && (
          <i
            className="icon-info-blue input-tooltip_icon"
            tabIndex="0"
            onClick={() => {
              this.setState({
                toolTipVisible: !this.state.toolTipVisible
              });
            }}
            onKeyPress={e => {
              handleKeyPress(e, () => {
                this.setState({
                  toolTipVisible: !this.state.toolTipVisible
                });
              });
            }}
            title="Click for more information"
          />
        )}
        {this.props.children}
        <div
          className={
            this.state.toolTipVisible
              ? "tooltipContent input-tooltip transition-input-tooltip"
              : "tooltipContent input-tooltip transition-input-tooltip hide"
          }
        >
          {this.props.tooltipContent}
        </div>
      </React.Fragment>
    );
  }
}

export default InputTooltipIcon;
